<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";
import axios from "axios";

const props = defineProps({
    open: Boolean,
    appointment: Object,
    stati: Array,
    status: Number,
});

const open = ref(props.open);
const appointment = ref(props.appointment);
const status = ref(props.status);
let rnd = Math.random().toString(36).slice(2, 7);

const closeOnEscape = (e) => {
    if (open.value && e.key === "Escape") {
        open.value = false;
    }
};

function selectStatus(statusIndex) {
    open.value = false;
    //console.log(statusIndex, this.appointment.id);

    // set new status
    axios
        .post("/status/update", {
            params: {
                appointment: appointment.value.id,
                status: statusIndex,
            },
        })
        .then((response) => {
            //console.log("response", response);
            status.value = statusIndex;
        })
        .catch((err) => {});
}

onMounted(() => {
    document.addEventListener("keydown", closeOnEscape);

});
onUnmounted(() => document.removeEventListener("keydown", closeOnEscape));

function clickOnButton(e) {
    let coords = getCoords(e.target);
    let dropdown = document.getElementById("dropdownStati-" + rnd);
    dropdown.style.top = (coords.top + 20) + "px";
    dropdown.style.left = coords.left + "px";

    open.value = !open.value;
}

function getCoords(elem) { // crossbrowser version
    let box = elem.getBoundingClientRect();
    let body = document.body;
    let docEl = document.documentElement;
    let scrollTop = window.scrollY || docEl.scrollTop || body.scrollTop;
    let scrollLeft = window.scrollX || docEl.scrollLeft || body.scrollLeft;
    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;
    let top  = box.top +  scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;
    return { top: Math.round(top), left: Math.round(left) };
}
</script>

<template>
    <div class="relative z-50">
        <div
            @click.stop="clickOnButton"
            class="appointment-tag transition duration-150 ease-in-out cursor-pointer"
                :title="'Status: ' + stati[status].text"
                :style="`background-color:${stati[status].color};color:#fff;`"
            >
        </div>

        <!-- Full Screen Dropdown Overlay
        <div
            v-show="open"
            class="fixed inset-0 z-50"
            @click.stop="open = false"
        ></div>-->

            <transition
                enter-active-class="transition ease-out duration-200"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <Teleport to="body">
                    <div
                        v-show="open"
                        :id="'dropdownStati-' + rnd"
                        class="absolute z-50 rounded-md drop-shadow-2xl shadow-2xl orgin-top-left -left-2 w-72 text-black"
                        style="display: none"
                        @click.stop="open = false"
                    >
                        <div
                            class="rounded-md bg-white ring-1 ring-black ring-opacity-5 p-5"
                        >
                            <div class="text-lg font-semibold mb-4">
                                Status bearbeiten
                            </div>

                            <div
                                v-for="(status, index) in stati"
                                class="dropdown-status py-1 my-1 font-semibold"
                                @click.stop="selectStatus(index)"
                            >
                                <span
                                    :style="`background-color:${status.color};color:#fff`"
                                    class="px-1 py-0.5 border border-slotBadgeBorder rounded mr-2"
                                >
                                    &nbsp;&nbsp;
                                </span>
                                {{ status.text }}
                            </div>
                        </div>
                    </div>
                </Teleport>
            </transition>

    </div>
</template>
